// @flow
export { default } from './ResetTemplate';



// WEBPACK FOOTER //
// ./src/components/reset/ResetTemplate/index.js